import {
  AgxButton,
  AgxEmailOutline,
  AgxPhoneOutline,
  ColumnConfig,
  ITableCell,
  TableRowProps,
} from '@urbanx/agx-ui-components'
import { useMemo } from 'react'
import IconText from 'components/icon-text/IconText'
import { AgencySupplier } from '@urbanx/agx.agencies.client'

const columnConfig = [
  { name: 'Company Name', widthInfo: { percent: 18 } },
  { name: 'Email', widthInfo: { percent: 22 } },
  { name: 'Phone', widthInfo: { percent: 18 } },
  { name: 'Note' },
  { name: '', widthInfo: { percent: 3 } },
] satisfies ColumnConfig[]

const useAgencySupplierTableConfig = (
  suppliers: AgencySupplier[],
  editSupplierClick: (index: number) => void
): [ColumnConfig[], TableRowProps[]] => {
  const rows = useMemo(() => {
    return suppliers.map((supplier, index) => {
      const cells: ITableCell[] = [
        {
          columnConfig: columnConfig[0],
          children: supplier?.companyName,
        },
        {
          columnConfig: columnConfig[1],
          children: (
            <IconText
              icon={<AgxEmailOutline width={22} height={22} />}
              text={supplier?.email?.address ?? ''}
              wordBreak="break-all"
            />
          ),
        },
        {
          columnConfig: columnConfig[2],
          children: (
            <IconText
              icon={<AgxPhoneOutline width={22} height={22} />}
              text={supplier?.phone?.number ?? ''}
            />
          ),
        },
        {
          columnConfig: columnConfig[3],
          children: supplier?.notes,
        },
        {
          columnConfig: columnConfig[4],
          children: (
            <AgxButton
              text={'Edit'}
              hollow
              medium
              onClick={() => editSupplierClick(index)}
            />
          ),
        },
      ]

      return {
        cells: cells,
        id: `supplier-${index}`,
        isMobile: false,
      } as TableRowProps
    })
  }, [suppliers, columnConfig])

  return [columnConfig, rows]
}

export default useAgencySupplierTableConfig
